/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import * as React from "react";
import {
  Action,
  ActionModalState,
  /*DeleteModalState,*/ Reportedperiod,
  EditReportType,
  /*GroupedDataByKey,/* GroupedDataByKey,*/ IEditReportProps,
  InternalInvoiceEdit,
  InternalInvoiceReport,
  InternalInvoiceWithCsrdAndGroupId,
  InvoicesWithCsrdAndGroupId,
  ReportDataMapping,
  /*ReportedPeriodReportType,*/ /*,  InvoiceReportTextFileds,*/ /*InternalKeysForEIRT,*/ StandardInvoiceReport,
  ConfirmButtonActions,
  MovedDateInvoice,
} from "./editTypes";
import { Invoice } from "../../services/API/Invoices";
import { DataService } from "../../services/DataService";
import { Contract } from "../../services/API/Contracts";
import Spinner from "react-bootstrap/esm/Spinner";
import { StandardInvoiceReportView } from "./StandardInvoiceReportView";
import { Customer } from "../../services/API/Customer";
import { editUtils } from "./editUtils";
import {
  Department,
  DepartmentFunctionArgs,
} from "../../services/API/Departments";
import { mapHistoryListToUi } from "./historyAdapter";

interface IEDitreportState {
  data?: /*GroupedDataByKey*/ any;
  loading: boolean;
  contract: Contract[];
  actionModal: ActionModalState /*DeleteModalState*/;
  customers: Customer[];
  submitActive: boolean;
  blockSubmitButton: boolean;
  editHistory: any;
  departments?: Department[];
  department?: Department;
  searchCache: {
    searchString: string;
    active: boolean;
    searchResult: { rowsFound: number /*,data?:any*/ };
  };
  searchLoading: boolean;
  reportedPeriods: { [key: string]: Reportedperiod[] };
  movedItems: MovedDateInvoice[];
  noRowsLeft: boolean;
  deleteReport: boolean;
}
export class EditReport extends React.Component<
  IEditReportProps,
  IEDitreportState
> {
  timerHandler: NodeJS.Timeout | null = null;

  constructor(props: IEditReportProps) {
    super(props);
    this.callBack = this.callBack.bind(this);
    this.invoiceReportOnChange = this.invoiceReportOnChange.bind(this);
    this.createRightTypeForReportDataInStateAndClone =
      this.createRightTypeForReportDataInStateAndClone.bind(this);
    this.copyRow = this.copyRow.bind(this);
    this.state = {
      data: undefined,
      loading: true,
      contract: [],
      actionModal: { action: "NONE", show: false, id: -1 },
      customers: [],
      submitActive: false,
      blockSubmitButton: false,
      editHistory: undefined,
      searchCache: {
        searchString: "",
        active: false,
        searchResult: { rowsFound: 0 /*,data:undefined*/ },
      },
      searchLoading: false,
      reportedPeriods: {},
      movedItems: [],
      noRowsLeft: false,
      deleteReport: false,
    };
  }
  /**
   * Lifecycle method that runs when the component is mounted.
   * Fetches necessary data such as report history, reported periods, departments, customers, and contracts.
   * Updates the state with the retrieved data.
   *
   * @returns A Promise that resolves when all data is fetched and state is updated.
   */
  async componentDidMount(): Promise<void> {
    const alreadyReportedOn =
      await DataService.EditedReports.GetPeriodsAlreadyReportedOn(
        this.props.data[this.props.reportType].report.supplierOrgId,
      );
    //console.log(this.props.data)
    const rawEditHistory = await DataService.EditedReports.GetReportHistory(
      this.props.data[this.props.reportType].report.batchId,
    );
    const editHistory = mapHistoryListToUi(rawEditHistory as any[]);

    const departments = await DataService.Departments.Get({
      supplierOrgId:
        this.props.data[this.props.reportType].report.supplierOrgId,
    } as DepartmentFunctionArgs);
    let department: Department | undefined = undefined;
    if (typeof departments !== "undefined") {
      department = departments.find(
        (x) =>
          x.id == this.props.data[this.props.reportType].report.departmentId,
      );
    }
    const customers = await DataService.Customers.Get({
      select: ["isSupplier", "kndOrgnr", "kndNamn", "kndNamnKey", "kndLopnr"],
      filter: "isSupplier eq false",
    });
    const contracts = await DataService.Contracts.GetBySupplierOrgNr(
      this.props.data[this.props.reportType].report.supplierOrgId,
    );
    const res = structuredClone(this.props.data[this.props.reportType]);

    if (res?.report?.csrd) {
      const addedMarkerOnInvoicesArray: InternalInvoiceEdit[] =
        res?.report?.invoices?.map((x: Invoice) => ({
          ...x,
          csrdConnectionId: Math.random(),
        })) ?? [];

      const connectedMarkerOnCsrdGroupArray: InternalInvoiceWithCsrdAndGroupId[] =
        (res?.report?.csrdGroup ?? [])
          .map((x: InvoicesWithCsrdAndGroupId) => {
            const invoiceMarker = addedMarkerOnInvoicesArray.find(
              (q) => q.invoiceNumber == x.invoiceNumber,
            );
            if (invoiceMarker !== undefined) {
              return { ...x, csrdConnectionId: invoiceMarker.csrdConnectionId };
            }
            return undefined;
          })
          .filter(
            (x: any): x is InternalInvoiceWithCsrdAndGroupId => x !== undefined,
          );

      res.report.invoices = addedMarkerOnInvoicesArray;
      res.report.csrdGroup = connectedMarkerOnCsrdGroupArray;
    }

    this.setState(
      {
        data: res,
        contract: contracts,
        customers,
        departments,
        department,
        editHistory,
        reportedPeriods:
          typeof alreadyReportedOn !== "undefined" ? alreadyReportedOn : {},
      },
      () => this.setState({ loading: false }),
    );
  }
  /**
   * Lifecycle method that runs when the component is about to unmount.
   * Clears the timeout if a search timer is active.
   */
  componentWillUnmount(): void {
    if (this.timerHandler) {
      clearTimeout(this.timerHandler);
    }
  }
  /**
   * Handles form submission for submitting an edited report.
   * Updates the state to indicate submission is in progress.
   * If the submission fails, displays an error modal.
   * If the submission is successful, navigates to the invoice report list.
   */
  handleSubmit = async (deleteReport?: boolean) => {
    this.setState({ submitActive: true });
    //console.log(deleteReport)
    const response = await DataService.EditedReports.SubmitEditedReport(
      this.props.reportType,
      this.state.data,
      this.state.movedItems,
      deleteReport,
    );
    if (!response?.ok) {
      this.setState({
        submitActive: false,
        actionModal: { action: "ERROR", show: true, id: -1 },
      });
    } else {
      this.setState({
        submitActive: false,
        actionModal: { action: "NONE", show: false, id: -1 },
      });
      window.location.href = "/invoice-report-list";
    }
  };
  /**
   * Handles the state of the action modal.
   *
   * @param action - The action to be performed (e.g., 'ERROR', 'NONE').
   * @param show - Boolean indicating whether the modal should be displayed.
   * @param id - The ID related to the action being performed.
   * @param key - (Optional) A specific key from `InvoicesWithCsrdAndGroupId` (e.g., 'groupId' or 'id').
   * @param item - (Optional) The item related to the modal action.
   * @param index - (Optional) The index of the item in a list.
   */
  handleActionModal = (
    action: Action,
    show: boolean,
    id: number,
    key?: keyof Pick<InvoicesWithCsrdAndGroupId, "groupId" | "id">,
    item?: any,
    index?: number,
  ) => {
    this.setState({ actionModal: { action, show, id, key, item, index } });
  };
  handleTypeaheadBlur<T>(value: string, rowId: number, key: keyof T) {}
  /**
   * Copies a row from the invoice report and adds it as a new entry.
   * @param rowToCopy - The row object to be copied.
   * @param index - The index of the row being copied.
   */
  copyRow<T extends object>(rowToCopy: T, index: number) {
    if (this.props.reportType == "Invoicereport") {
      const buff: StandardInvoiceReport =
        this.createRightTypeForReportDataInStateAndClone(this.props.reportType);
      const copiedItem: InternalInvoiceEdit /*Invoice*/ = structuredClone(
        rowToCopy,
      ) as InternalInvoiceEdit; /*Invoice*/
      copiedItem.id = copiedItem.id + 1;
      copiedItem.invoiceNumber = "";
      buff.report.invoices?.push(copiedItem);
      buff.report.noOfInvoices = buff.report.invoices?.length ?? 0;
      buff.report.noOfInvoicesImported = buff.report.invoices?.length ?? 0;
      const totSum: number = editUtils.CalculateNewSumTotal(
        buff,
        "invoices",
        "priceExcMoms",
      );
      buff.report.totalSumExclMoms = totSum;
      buff.report.totalSumExclMomsImported = totSum;
      this.setState({
        data: buff,
        actionModal: { action: "NONE", show: false, id: -1 },
      });
    } else if (this.props.reportType == "InvoicereportWithCSRD") {
      if ("items" in rowToCopy) {
        const tempId = Math.random();
        let invoiceSum: number = 0;
        const date = new Date();
        date.setDate(date.getDate() + 30);
        const buff: StandardInvoiceReport =
          this.createRightTypeForReportDataInStateAndClone(
            "InvoicereportWithCSRD",
          );
        const copyToAdd = structuredClone(
          rowToCopy.items,
        ) as InternalInvoiceWithCsrdAndGroupId[]; /*InvoicesWithCsrdAndGroupId[]*/
        const newGroupId = this.findNewGroupId(
          this.state.data?.report?.csrdGroup,
          "groupId",
        );
        copyToAdd.forEach((x, index) => {
          invoiceSum += x.rowSumExclMoms;
          buff.report.csrdGroup?.push({
            ...x,
            csrdConnectionId: tempId,
            id: index == 0 ? tempId : Math.random(),
            groupId: newGroupId,
            invoiceNumber: "",
            invoiceId: tempId,
            billingDate: new Date(),
          });
        });
        const totSumForReport: number = editUtils.CalculateNewSumTotal(
          buff,
          "csrdGroup",
          "rowSumExclMoms",
        );
        const newInvoiceToPushToInvoices: InternalInvoiceEdit = {
          supplierOrgId: copyToAdd[0].supplierOrgId,
          contractId: copyToAdd[0].contractId,
          customerOrgId: copyToAdd[0].customerOrgId,
          customerId: copyToAdd[0].customerName,
          priceExcMoms: invoiceSum,
          priceIncMoms: invoiceSum * 0.25 + invoiceSum,
          id: tempId,
          invoiceNumber: "",
          csrdConnectionId: tempId,
          isRemoved: false,
          billingDate: new Date(),
          noOfInvoices: copyToAdd.length,
          dueDate: date,
          sendDate: new Date(),
          customerName: copyToAdd[0].customerName,
          type: copyToAdd[0].type,
          filePath: copyToAdd[0].filePath,
        }; /*Invoice*/
        buff.report.invoices?.push(newInvoiceToPushToInvoices);
        buff.report.noOfInvoices = buff.report.invoices?.length ?? 0;
        buff.report.noOfInvoicesImported = buff.report.invoices?.length ?? 0;
        buff.report.totalSumExclMoms = totSumForReport;
        buff.report.totalSumExclMomsImported = totSumForReport;
        this.setState({
          data: buff,
          actionModal: { action: "NONE", show: false, id: -1 },
        });
      }
    }
  }
  /**
   * Finds the highest existing group ID or invoice ID in the provided invoices list
   * and returns a new unique group ID by incrementing the highest found value.
   * @param invoices - The list of invoices to search for the highest ID.
   * @param path - The key indicating whether to find a new invoiceId or groupId.
   * @returns The next available unique group ID.
   */

  private findNewGroupId = (
    invoices: InvoicesWithCsrdAndGroupId[] | undefined,
    path: keyof Pick<InvoicesWithCsrdAndGroupId, "invoiceId" | "groupId">,
  ) => {
    if (!invoices || invoices.length === 0) {
      return 1;
    }

    const highestGroupId =
      invoices
        .map((inv) => inv[path] as number)
        .filter((grpId, i, self) => self.indexOf(grpId) === i)
        .sort((a, b) => b - a)
        .find((t) => t) ?? -1;

    return highestGroupId > 0 ? highestGroupId + 1 : 1;
  };

  /**
   * Adds a new row to the invoice report.
   * @param groupId - (Optional) The group ID to which the new row should belong.
   */
  addRow = (groupId?: number) => {
    if (
      this.props.reportType == "Invoicereport" ||
      this.props.reportType == "Projectreport"
    ) {
      const buff: StandardInvoiceReport =
        this.createRightTypeForReportDataInStateAndClone(this.props.reportType);
      const newInvoice: InternalInvoiceEdit /*Invoice*/ = {
        id: buff.report.invoices?.length ?? -1,
        invoiceNumber: "",
        supplierOrgId: buff?.report?.supplierOrgId,
        customerId: "",
        customerOrgId: "",
        contractId: "",
        priceExcMoms: 0,
        priceIncMoms: 0,
        isRemoved: false,
        billingDate: new Date(),
        noOfInvoices: 1,
        dueDate: new Date(),
        sendDate: new Date(),
        customerName: "",
        type: 1,
        filePath: "",
        csrdConnectionId: Math.random(),
      };
      buff.report.invoices?.push(newInvoice);
      buff.report.noOfInvoices = buff.report.invoices?.length ?? 0;
      buff.report.noOfInvoicesImported = buff.report.invoices?.length ?? 0;
      this.setState({
        data: buff,
        actionModal: { action: "NONE", show: false, id: -1 },
      });
    } else if (
      this.props.reportType == "InvoicereportWithCSRD" ||
      this.props.reportType == "ProjectreportWithCSRD"
    ) {
      const buff: StandardInvoiceReport =
        this.createRightTypeForReportDataInStateAndClone(this.props.reportType);
      const firstCsrdRow = this.state.data?.report.csrdGroup?.[0];
      const currentValues = buff.report.csrdGroup?.find(
        (x: InternalInvoiceWithCsrdAndGroupId /*InvoicesWithCsrdAndGroupId*/) =>
          x.groupId == groupId,
      );
      const tempId = Math.random();
      const newRow: InternalInvoiceWithCsrdAndGroupId = {
        id: tempId,
        groupId:
          typeof groupId == "undefined"
            ? this.findNewGroupId(this.state.data?.report.csrdGroup, "groupId")
            : groupId,
        billingDate:
          typeof groupId == "undefined"
            ? new Date()
            : (currentValues?.billingDate ?? new Date()),
        contractId:
          typeof groupId == "undefined"
            ? ""
            : (currentValues?.contractId ?? ""),
        customerName:
          typeof groupId == "undefined"
            ? ""
            : (currentValues?.customerName ?? ""),
        customerOrgId:
          typeof groupId == "undefined"
            ? ""
            : (currentValues?.customerOrgId ?? ""),
        invoiceNumber:
          typeof groupId == "undefined"
            ? ""
            : (currentValues?.invoiceNumber ?? ""),
        rowSumExclMoms: 0,
        articleQuantity: 0,
        articlePricePerUnit: 0,
        articleNumber: "",
        articleText: "",
        articleQuantityType: "",
        invoiceId:
          typeof this.state.actionModal.index == "undefined"
            ? this.findNewGroupId(
                this.state.data?.report.csrdGroup,
                "invoiceId",
              )
            : (currentValues?.invoiceId ?? -1),
        filePath: firstCsrdRow?.filePath ?? this.state.data?.report.filePath ?? "",
        type: 1,
        status: firstCsrdRow?.status ?? 1,
        batchId: firstCsrdRow?.batchId ?? this.state.data?.report.batchId,
        supplierOrgId: this.state.data?.report.supplierOrgId,
        csrdConnectionId: tempId,

        // Keep stable membership keys for snapshotting.
        projectName:
          typeof groupId == "undefined"
            ? ""
            : ((currentValues as any)?.projectName ?? ""),
        invoiceReference:
          typeof groupId == "undefined"
            ? ""
            : ((currentValues as any)?.invoiceReference ?? ""),
        invoiceIdentifier:
          typeof groupId == "undefined"
            ? ""
            : ((currentValues as any)?.invoiceIdentifier ?? ""),
        uiGroupId: String(
          typeof groupId == "undefined"
            ? this.findNewGroupId(this.state.data?.report.csrdGroup, "groupId")
            : ((currentValues as any)?.groupId ?? ""),
        ),
        uiUniqueRowId:
          globalThis.crypto && "randomUUID" in globalThis.crypto
            ? (globalThis.crypto as any).randomUUID()
            : String(tempId),
      };
      buff.report.csrdGroup?.push(newRow);
      const newInvoice: InternalInvoiceEdit /*Invoice*/ = {
        id: tempId,
        invoiceNumber: "",
        supplierOrgId: this.state.data?.report.supplierOrgId,
        customerId: "",
        customerOrgId: "",
        contractId: "",
        priceExcMoms: 0,
        priceIncMoms: 0,
        isRemoved: false,
        billingDate: new Date(),
        noOfInvoices: 1,
        dueDate: new Date(),
        sendDate: new Date(),
        customerName: "",
        type: 1,
        filePath: "",
        csrdConnectionId: tempId,
      };
      if (typeof groupId == "undefined") {
        buff.report.invoices?.push(newInvoice);
        buff.report.noOfInvoices = buff.report.invoices?.length ?? 0;
        buff.report.noOfInvoicesImported = buff.report.invoices?.length ?? 0;
      }

      this.setState(
        {
          data: buff,
          actionModal: { action: "NONE", show: false, id: -1 },
        } /*,()=> console.log(this.state.data)*/,
      );
    }
  };
  /**
   * Deletes a row from the invoice report based on the provided ID.
   * Updates the total sum and invoice count after deletion.
   * @param id - The ID of the row to be deleted.
   */
  deleteRow = (id: number) => {
    if (
      this.props.reportType == "Invoicereport" ||
      this.props.reportType == "Projectreport"
    ) {
      const buff: StandardInvoiceReport =
        this.createRightTypeForReportDataInStateAndClone(this.props.reportType);
      buff.report.invoices = buff.report.invoices?.filter(
        (x) => x.id !== this.state.actionModal.id,
      );
      if (buff.report.invoices?.length == 0) {
        buff.report.totalSumExclMoms = 0;
        buff.report.totalSumExclMomsImported = 0;
      }
      const totSum: number = editUtils.CalculateNewSumTotal(
        buff,
        "invoices",
        "priceExcMoms",
      );
      buff.report.totalSumExclMoms = totSum;
      buff.report.totalSumExclMomsImported = totSum;
      buff.report.noOfInvoices = buff.report.invoices?.length ?? 0;
      buff.report.noOfInvoicesImported = buff.report.invoices?.length ?? 0;

      this.setState(
        { data: buff, actionModal: { action: "NONE", show: false, id: -1 } },
        () =>
          this.setState(
            {
              searchCache: {
                ...this.state.searchCache,
                searchString:
                  this.state.searchCache.searchResult.rowsFound - 1 > 0
                    ? this.state.searchCache.searchString
                    : "",
                active: this.state.searchCache.searchResult.rowsFound - 1 > 0,
                searchResult: {
                  ...this.state.searchCache.searchResult,
                  rowsFound: this.state.searchCache.searchResult.rowsFound - 1,
                },
              },
            } /*,()=> console.log(this.state.searchCache)*/,
          ),
      );
    } else if (
      (this.props.reportType == "InvoicereportWithCSRD" ||
        this.props.reportType == "ProjectreportWithCSRD") &&
      typeof this.state.actionModal?.key !== "undefined"
    ) {
      const key = this.state.actionModal.key;
      const buff: StandardInvoiceReport =
        this.createRightTypeForReportDataInStateAndClone(this.props.reportType);
      const itemToLookUp: InternalInvoiceWithCsrdAndGroupId | undefined =
        buff.report.csrdGroup?.filter(
          (x) => x[key] == this.state.actionModal.id,
        )[0];

      buff.report.csrdGroup = buff.report.csrdGroup?.filter(
        (x) => x[key] !== this.state.actionModal.id,
      );

      if (itemToLookUp !== undefined) {
        const remainingItems = buff.report.csrdGroup?.filter(
          (x) => x.invoiceNumber == itemToLookUp.invoiceNumber,
        );

        if (remainingItems !== undefined && remainingItems?.length > 0) {
          const newInvoiceSum = remainingItems.reduce((acc, curr) => {
            return acc + curr.rowSumExclMoms;
          }, 0);
          const invoiceIndex = buff.report.invoices?.findIndex(
            (x) => x.invoiceNumber == itemToLookUp.invoiceNumber,
          );

          if (
            invoiceIndex !== undefined &&
            buff.report.invoices !== undefined
          ) {
            buff.report.invoices[invoiceIndex].priceExcMoms = newInvoiceSum;
            buff.report.invoices[invoiceIndex].priceIncMoms =
              newInvoiceSum * 0.25 + newInvoiceSum;
          }
        } else {
          buff.report.invoices = buff.report.invoices?.filter(
            (x) => x.invoiceNumber !== itemToLookUp.invoiceNumber,
          );
        }
      }
      const totSum: number = editUtils.CalculateNewSumTotal(
        buff,
        "csrdGroup",
        "rowSumExclMoms",
      );
      buff.report.totalSumExclMoms = totSum;
      buff.report.totalSumExclMomsImported = totSum;
      buff.report.noOfInvoices = buff.report.invoices?.length ?? 0;
      buff.report.noOfInvoicesImported = buff.report.invoices?.length ?? 0;
      this.setState(
        { data: buff, actionModal: { action: "NONE", show: false, id: -1 } },
        () =>
          this.setState(
            {
              searchCache: {
                ...this.state.searchCache,
                active: this.state.searchCache.searchResult.rowsFound - 1 > 0,
                searchResult: {
                  ...this.state.searchCache.searchResult,
                  rowsFound: this.state.searchCache.searchResult.rowsFound - 1,
                },
              },
            } /*,()=> console.log(this.state.searchCache)*/,
          ),
      );
      /*
      ,() => 
            this.setState({searchCache:{...this.state.searchCache,
              searchResult:{...this.state.searchCache.searchResult,rowsFound:this.state.searchCache.searchResult.rowsFound+ 1}}},()=> console.log(this.state.searchCache))
      */
    }
  };
  /**
   * Handles changes in invoice details and updates the state accordingly.
   * Also recalculates totals when CSRD articles change.
   * @param item - The item being updated.
   * @param index - (Optional) The index of the item in the list.
   * @param key - (Optional) The key of the property being updated.
   */
  callBack<T extends object>(item: T, index?: number, key?: keyof T) {
    const buff = this.createRightTypeForReportDataInStateAndClone(
      this.props.reportType,
    );

    if (this.props.reportType == "Invoicereport") {
    }
    if (key == "rowSumExclMoms") {
      const rowSum = { ...item } as InternalInvoiceWithCsrdAndGroupId;
      buff.report.priceExcMoms =
        buff.report.priceExcMoms + rowSum.rowSumExclMoms;
    }
    if (
      (this.props.reportType == "Invoicereport" ||
        this.props.reportType == "Projectreport") &&
      /*buff !== undefined && buff['report'] !== undefined &&*/ buff["report"]
        ?.invoices !== undefined &&
      index !==
        undefined /*&& key == ('customerName'||'customerOrgId'||'contractId')*/
    ) {
      const invoice = { ...item } as InternalInvoiceEdit; /*Invoice*/
      const customerId = this.state.customers.filter(
        (x) => x.kndOrgnr == +invoice.customerOrgId,
      )[0];
      if (customerId !== undefined) {
        invoice.customerId = customerId.kndLopnr.toString();
      }

      let targetIndex = index ?? -1;

      if (
        this.state.searchCache.active &&
        this.state.searchCache.searchResult.rowsFound > 0
      ) {
        const searchIndex = buff.report.invoices.findIndex(
          (x: any) => x.invoiceNumber == invoice.invoiceNumber,
        );
        if (searchIndex >= 0) {
          targetIndex = searchIndex;
        }
      }

      invoice.priceIncMoms = invoice.priceExcMoms * 0.25 + invoice.priceExcMoms;
      if (targetIndex >= 0) {
        buff.report.invoices[targetIndex] = invoice;
      }

      const totSum: number = editUtils.CalculateNewSumTotal(
        buff,
        "invoices",
        "priceExcMoms",
      );

      buff.report.totalSumExclMoms = totSum;
      buff.report.totalSumExclMomsImported = totSum;
      this.setState({ data: buff });
    } else if (
      (this.props.reportType == "InvoicereportWithCSRD" ||
        this.props.reportType == "ProjectreportWithCSRD") &&
      /*buff !== undefined && buff['report'] !== undefined && */ buff["report"]
        ?.csrdGroup !== undefined &&
      index !== undefined
    ) {
      const foundIndex = buff.report.csrdGroup.findIndex(
        (x: InternalInvoiceWithCsrdAndGroupId /*InvoicesWithCsrdAndGroupId*/) =>
          x.id == index,
      );
      if (foundIndex > -1) {
        // Preserve project snapshot membership fields during edits.
        // Some edit UI paths send partial row objects, so a straight assignment can
        // accidentally drop these fields and cause snapshot-enforced saves to fail.
        const existing = buff.report.csrdGroup[
          foundIndex
        ] as InternalInvoiceWithCsrdAndGroupId;
        const incoming = (item ??
          {}) as Partial<InternalInvoiceWithCsrdAndGroupId>;
        const merged: InternalInvoiceWithCsrdAndGroupId = {
          ...existing,
          ...incoming,
        } as InternalInvoiceWithCsrdAndGroupId;

        if (key === "articleQuantity" || key === "articlePricePerUnit") {
          const quantity = Number(
            String(merged.articleQuantity ?? 0).replace(",", "."),
          );
          const pricePerUnit = Number(
            String(merged.articlePricePerUnit ?? 0).replace(",", "."),
          );
          merged.rowSumExclMoms =
            Number.isFinite(quantity) && Number.isFinite(pricePerUnit)
              ? quantity * pricePerUnit
              : 0;
        }

        const preserveKeys: (keyof InternalInvoiceWithCsrdAndGroupId)[] = [
          "projectName",
          "invoiceReference",
          "invoiceIdentifier",
          "uiGroupId",
          "uiUniqueRowId",
        ];

        preserveKeys.forEach((k) => {
          if (merged[k] === undefined || merged[k] === null) {
            (merged as any)[k] = (existing as any)[k];
          }
        });

        buff.report.csrdGroup[foundIndex] = merged;
      }
      if (
        key == "customerName" ||
        key == "customerOrgId" ||
        key == "contractId"
      ) {
        const group =
          item as InternalInvoiceWithCsrdAndGroupId; /*InvoicesWithCsrdAndGroupId*/
        let matches = buff.report.csrdGroup.filter(
          (
            x: InternalInvoiceWithCsrdAndGroupId /*InvoicesWithCsrdAndGroupId*/,
          ) => x.groupId == group.groupId,
        );
        matches.forEach(
          (
            x: InternalInvoiceWithCsrdAndGroupId /*InvoicesWithCsrdAndGroupId*/,
          ) => {
            x.contractId = group.contractId;
            x.customerName = group.customerName;
            x.customerOrgId = group.customerOrgId;
          },
        );
      }
      const totSum: number = editUtils.CalculateNewSumTotal(
        buff,
        "csrdGroup",
        "rowSumExclMoms",
      );
      buff.report.totalSumExclMoms = totSum;
      buff.report.totalSumExclMomsImported = totSum;
      this.setState({ data: buff }, () =>
        this.setState({
          data: editUtils.UpdateMainInvoiceWhenChangeOccursOnCsrdArticleRows(
            this.state.data,
            item as InternalInvoiceWithCsrdAndGroupId,
            this.state.customers,
          ),
        }),
      );
    }
  }
  /**
   * Handles changes to the department ID or comment in the invoice report.
   * Updates the state with the new values.
   * @param e - The event object from the input field or the updated number value.
   * @param key - The key representing either 'departmentId' or 'comment'.
   * @param item - (Optional) The invoice report object being updated.
   */
  invoiceReportOnChange(
    e: React.ChangeEvent<HTMLTextAreaElement> | number,
    key: keyof Pick<InternalInvoiceReport, "departmentId" | "comment">,
    item?: InternalInvoiceReport /*InvoiceReport*/,
  ) {
    const buff: StandardInvoiceReport = structuredClone(
      this.state?.data,
    ) as StandardInvoiceReport;
    if (buff !== undefined && buff["report"] !== undefined) {
      if (key == "comment" && typeof e !== "number") {
        buff.report.comment = e.target.value;
        this.setState({ data: buff });
      } else if (key == "departmentId" && typeof e == "number") {
        buff.report.departmentId = this.state.actionModal.id;
        const newDepartment = this.state.departments?.find((x) => x.id == e);
        this.setState({
          data: buff,
          department: newDepartment,
          actionModal: { action: "NONE", show: false, id: -1 },
        });
      }
    }
  }
  /**
   * Clones the existing report data and returns the correct structure based on the report type.
   * @param reportType - The type of report to generate.
   * @returns A new instance of the report data structure matching the given report type.
   */
  createRightTypeForReportDataInStateAndClone<T extends EditReportType>(
    reportType: EditReportType,
  ): ReportDataMapping[T] {
    const buff: ReportDataMapping = {
      Invoicereport:
        (structuredClone(this.state?.data) as StandardInvoiceReport) ?? {},
      InvoicereportWithCSRD:
        (structuredClone(this.state?.data) as StandardInvoiceReport) ?? {},
      Kickbackreport: {},
      Logs: {},
      Projectreport:
        (structuredClone(this.state?.data) as StandardInvoiceReport) ?? {},
      ProjectreportWithCSRD:
        (structuredClone(this.state?.data) as StandardInvoiceReport) ?? {},
    };
    return buff[reportType];
  }
  /**
   * Logs the movement of items, including period, invoice ID, report type, and batch ID.
   * Handles the state of the content that should be displayed in the actionmodal.
   * @param period - The period associated with the moved item.
   * @param item - The item being moved.
   * @param reportType - The type of report the item belongs to.
   * @param action - The action performed (e.g., move, delete).
   * @param batchId - (Optional) The batch ID associated with the moved item.
   */
  movedItems = (
    period: string,
    item: any,
    index: number,
    reportType: "InvoiceReport" | "NullReport",
    action: ConfirmButtonActions,
    supplierOrgId: string,
    batchId?: string,
    departmentId?: number,
  ) => {
    const buff: MovedDateInvoice = {
      period,
      id: item.id,
      invoiceId: item.invoiceId,
      reportType,
      action,
      batchId,
      supplierOrgId: item.supplierOrgId,
      departmentId,
    };
    const res = editUtils.ManageDateActions(this.state.movedItems, buff);
    this.setState({ movedItems: res }, () => {
      if (res.length == this.state.data.report.invoices.length) {
        this.setState(
          { noRowsLeft: true } /*,()=> console.log(this.state.movedItems)*/,
        );
      } else {
        this.setState(
          { noRowsLeft: false } /*,()=> console.log(this.state.movedItems)*/,
        );
      }
    });
  };
  /**
   * Checks if the current report contains logs and conditionally renders the appropriate report view.
   * @returns The appropriate report component based on whether logs exist.
   */
  returnBasedOnStandardReportContainsLogsOrNot = () => {
    const hasLogs = "Logs" in this.state.data;
    return (
      <>
        {this.state.data !== undefined &&
          (this.props.reportType == "Invoicereport" ||
            this.props.reportType == "Projectreport") && (
            <StandardInvoiceReportView
              searchLoading={this.state.searchLoading}
              searchCache={this.state.searchCache}
              search={this.handleSearchCache}
              editHistory={this.state.editHistory}
              department={this.state.department}
              departments={this.state.departments}
              submitActive={this.state.submitActive}
              submit={this.handleSubmit}
              customers={this.state.customers}
              contract={this.state.contract}
              copyRow={this.copyRow}
              handleDeleteModal={this.handleActionModal}
              deleteModal={this.state.actionModal}
              deleteRow={this.deleteRow}
              addRow={this.addRow}
              data={
                this.state.searchCache.active &&
                this.state.searchCache.searchResult.rowsFound > 0
                  ? {
                      ...this.state.data.report,
                      invoices: this.state.data?.report?.invoices.filter(
                        (x: any) =>
                          x.invoiceNumber.includes(
                            this.state.searchCache.searchString,
                          ),
                      ),
                    } /*this.state.searchCache.searchResult.data.report*/
                  : this.state.data.report
              }
              reportType={this.props.reportType}
              logs={hasLogs ? this.props.data?.["Logs"] : undefined}
              invoiceReportOnChange={this.invoiceReportOnChange}
              callBack={this.callBack}
              reportedPeriods={this.state.reportedPeriods}
              movedItems={this.movedItems}
              noRowsLeft={this.state.noRowsLeft}
              resetReport={this.resetReport}
              editModeActive={this.props.editModeActive}
            />
          )}
      </>
    );
  };
  returnBasedOnStandardCsrdReportContainsLogsOrNot = () => {
    const hasLogs = "Logs" in this.props.data;
    return (
      <>
        {this.state.data !== undefined &&
          (this.props.reportType == "InvoicereportWithCSRD" ||
            this.props.reportType == "ProjectreportWithCSRD") && (
            <StandardInvoiceReportView
              searchLoading={this.state.searchLoading}
              searchCache={this.state.searchCache}
              search={this.handleSearchCache}
              editHistory={this.state.editHistory}
              department={this.state.department}
              departments={this.state.departments}
              submitActive={this.state.submitActive}
              submit={this.handleSubmit}
              customers={this.state.customers}
              contract={this.state.contract}
              copyRow={this.copyRow}
              handleDeleteModal={this.handleActionModal}
              deleteModal={this.state.actionModal}
              deleteRow={this.deleteRow}
              addRow={this.addRow}
              data={
                this.state.searchCache.active &&
                this.state.searchCache.searchResult.rowsFound > 0
                  ? /*this.state.searchCache.searchResult.data.report*/ {
                      ...this.state.data.report,
                      csrdGroup: this.state.data.report.csrdGroup.filter(
                        (x: any) =>
                          x.invoiceNumber.includes(
                            this.state.searchCache.searchString,
                          ),
                      ),
                      invoices: this.state.data.report.invoices.filter(
                        (x: any) =>
                          x.invoiceNumber.includes(
                            this.state.searchCache.searchString,
                          ),
                      ),
                    }
                  : this.state.data.report
              }
              reportType={this.props.reportType}
              logs={hasLogs ? this.props.data?.["Logs"] : undefined}
              invoiceReportOnChange={this.invoiceReportOnChange}
              callBack={this.callBack}
              reportedPeriods={this.state.reportedPeriods}
              movedItems={this.movedItems}
              noRowsLeft={this.state.noRowsLeft}
              resetReport={this.resetReport}
              editModeActive={this.props.editModeActive}
            />
          )}
      </>
    );
  };
  /**
   * Handles search caching by delaying the search execution using a timer.
   * If a new search string is entered before the timer completes, the previous timeout is cleared.
   * Updates the state to reflect search activity.
   *
   * @param searchString - The string entered by the user for searching invoices.
   * @returns A Promise that resolves when the search is triggered after the delay.
   */
  handleSearchCache = async (searchString: string): Promise<void> => {
    if (this.timerHandler) {
      clearTimeout(this.timerHandler);
    }
    this.setState({
      searchLoading: searchString.length > 0,
      searchCache:
        searchString.length == 0
          ? { searchString, active: false, searchResult: { rowsFound: 0 } }
          : { ...this.state.searchCache },
    });
    this.timerHandler = setTimeout(async () => {
      await this.searchOnInvoiceNumber(searchString);

      //this.setState({searchCache:''})
    }, 500);
  };
  /**
   * Searches for invoices by their invoice number and updates the state with the results.
   *
   * @param searchString - The string used to search for invoice numbers.
   * @returns A Promise that resolves when the search operation completes.
   */
  searchOnInvoiceNumber = async (searchString: string): Promise<void> => {
    this.setState({ searchLoading: true });
    const invoicesSearchRes = this.state.data?.report?.invoices?.filter(
      (x: any) => x.invoiceNumber.includes(searchString),
    );

    this.setState({
      searchLoading: false,
      searchCache: {
        searchString,
        active: searchString.length > 0,
        searchResult: {
          rowsFound: invoicesSearchRes?.length ?? 0 /*,data:buff*/,
        },
      },
    });
  };
  /**
   *
   * @param historyId
   * @returns
   */
  resetReport = async (
    historyId: number,
    forceRestore?: boolean,
  ): Promise<void> => {
    //console.log(historyId)
    this.setState({ submitActive: true });

    // If user already confirmed force, skip preflight.
    if (forceRestore) {
      const response = await DataService.EditedReports.ResetSelectedReport(
        historyId,
        this.props.reportType as string,
        true,
      );
      if (!response?.ok) {
        this.setState({
          submitActive: false,
          actionModal: { action: "ERROR", show: true, id: -1 },
        });
        return;
      }
      this.setState({
        submitActive: false,
        actionModal: { action: "NONE", show: false, id: -1 },
      });
      window.location.href = "/invoice-report-list";
      return;
    }

    const preflightRes =
      await DataService.EditedReports.PreflightResetSelectedReport(
        historyId,
        this.props.reportType as string,
      );
    const analysis = preflightRes ? await preflightRes.json() : null;

    if (analysis?.hasBlockingConflicts) {
      this.setState({
        submitActive: false,
        actionModal: {
          action: "RESET_CONFLICT",
          show: true,
          id: historyId,
          item: analysis,
        },
      });
      return;
    }

    const response = await DataService.EditedReports.ResetSelectedReport(
      historyId,
      this.props.reportType as string,
    );
    if (!response?.ok) {
      this.setState({
        submitActive: false,
        actionModal: { action: "ERROR", show: true, id: -1 },
      });
    } else {
      this.setState({
        submitActive: false,
        actionModal: { action: "NONE", show: false, id: -1 },
      });
      window.location.href = "/invoice-report-list";
    }
  };
  render() {
    return (
      <>
        <>
          {this.state.loading && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                flexWrap: "wrap",
                alignContent: "center",
              }}
            >
              <Spinner />
            </div>
          )}

          {!this.state.loading &&
            (this.props.reportType == "Invoicereport" ||
              this.props.reportType == "Projectreport") &&
            typeof this.state.data !== "undefined" &&
            this.returnBasedOnStandardReportContainsLogsOrNot()}
          {!this.state.loading &&
            (this.props.reportType == "InvoicereportWithCSRD" ||
              this.props.reportType == "ProjectreportWithCSRD") &&
            typeof this.state.data !== "undefined" &&
            this.returnBasedOnStandardCsrdReportContainsLogsOrNot()}
        </>
      </>
    );
  }
}
